import uitoolkit from "@zoom/videosdk-ui-toolkit";
import "@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import './zoomnew.css'

function ZoomApp() {
  const nav = useNavigate();
  let sessionContainer: HTMLDivElement | null = null;
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const sessionParam = queryParams.get("session");
  const zoomTokenParam = queryParams.get("zoomToken");
  const doctorName = queryParams.get("doctorName");
  const doctorId = queryParams.get("doctorId");
  const appointmentId = queryParams.get("appointmentId");
  const date = queryParams.get("date");

  const body = {
    date: date,
    doctorId: doctorId,
    appointmentId: appointmentId,
  };

  const config = {
    videoSDKJWT: zoomTokenParam || "",
    sessionName: sessionParam || "Default Session",
    userName: doctorName || "FV Hospital",
    sessionPasscode: "",
    features: ["video", "audio", "settings", "users"],
    options: { init: {enforceMultipleVideos: true}, audio: {}, video: {} },
  };

  useEffect(() => {
    if (sessionParam && zoomTokenParam) {
      sessionContainer = document.getElementById("sessionContainer") as HTMLDivElement;
      document.getElementById("join-flow")!.style.display = "none";
      joinSession();
    }
  }, [sessionParam, zoomTokenParam]);

  function joinSession() {
    if (sessionContainer) {
      uitoolkit.joinSession(sessionContainer, config);
      uitoolkit.onSessionClosed(sessionClosed);
    }
  }

  const sessionClosed = () => {
    console.log("session closed");
    uitoolkit.closeSession(sessionContainer!);
    document.getElementById("join-flow")!.style.display = "block";
    setTimeout(() => {
      nav("/appointment-aprove", {
        state: body,
      });
    }, 2000);
  };

  return (
    <div className="ZoomApp">
      <main>
        <div id="join-flow"></div>
        <div id="sessionContainer"></div>
      </main>
    </div>
  );
}

export default ZoomApp;
